import { BuilderConfig } from '../../types/Builder';

import BusinessHubIndustriesGrid from './business-hub-industries-grid';

export const BusinessHubIndustriesGridBuilderConfig = {
    name: 'Business Hub Industries Grid',
    inputs: [
        {
            name: 'showJustedBrands',
            type: 'boolean',
        },
        {
            name: 'autoplay',
            type: 'boolean',
            helperText: 'Also enable single mode',
        },
        {
            name: 'showTitle',
            type: 'boolean',
        },
    ],
};

const builderConfig: BuilderConfig<{}> = {
    component: BusinessHubIndustriesGrid,
    config: BusinessHubIndustriesGridBuilderConfig,
};

export default builderConfig;
